import { useState, useEffect } from "react";
import axiosConfig from '../axiosConfig';
import Header from "../Header/Header";
import Cookies from 'universal-cookie';


const ChangePass=()=>{
    const cookies = new Cookies();
    const [user_name,setUsername] = useState("");
    const [currentpassword,setcurrentPassword] = useState("");
    const [newpassword,setnewPassword] = useState("");
    const [confirmpass,setConfirmPassword] = useState("");

    const [validUpper, setValidUpper] = useState(false);
    const [validLower, setValidLower] = useState(false);
    const [validDigit, setValidDigit] = useState(false);
    const [validSpecial, setValidSpecial] = useState(false);
    const [validMinLength, setValidMinLength] = useState(false);
    const [showNewPassword, setShowNewPassword] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        setValidUpper(/[A-Z]/.test(newpassword));
        setValidLower(/[a-z]/.test(newpassword));
        setValidDigit(/\d/.test(newpassword));
        setValidSpecial(/[^A-Za-z0-9]/.test(newpassword));
        setValidMinLength(newpassword.length >= 8);
    }, [newpassword]);

    // useEffect(()=>{
    //     if(props.mode == "Edit"){
    //         axiosConfig.get("/appuser/get/"+props.id).then((rsp)=>{
    //             var obj = rsp.data;
    //             setUsername(obj.user_name);
    //             setEmail(obj.email);
    //             setAddress(obj.address);
    //             setPhone(obj.phone);
    //         }, (err) => {
    //             if (err.response.status === 422) {
    //                 setErrMsg(err.response.data);

    //             }
    //         });
    //     }


    // }, []);



    const [err_msg, setErrMsg] = useState({});
    const [mainerr_msg, setmainErrMsg] = useState("");

    // const refresh = () => {
    //     setErrMsg({});
    //     setUsername("");
    //     setEmail("");
    //     setAddress("");
    //     setPhone("");
    //     setPassword("");
    //     setCPassword("");
    // }

    const handleForm = (e) => {
        e.preventDefault();
        

            // client-side validation
            const errors = {};
            if (!currentpassword) errors.currentpassword = 'Current password is required';
            if (!newpassword) errors.newpassword = 'New password is required';
            if (!confirmpass) errors.confirmpass = 'Confirm password is required';
            if (newpassword && newpassword !== confirmpass) errors.confirmpass = 'Passwords do not match';
            if (newpassword) {
                if (!validMinLength || !validUpper || !validLower || !validDigit || !validSpecial) {
                    errors.newpassword = 'Password does not meet the requirements';
                }
            }

            if (Object.keys(errors).length > 0) {
                setErrMsg(errors);
                setmainErrMsg('');
                return;
            }

            const obj = {user_name:(cookies.get('username')),currentpassword:currentpassword,newpassword:newpassword,confirmpass:confirmpass};
            setIsSubmitting(true);
            setmainErrMsg('');
            setErrMsg({});

            axiosConfig.post("/appuser/changepass",obj).then((rsp)=>{
                setmainErrMsg(rsp.data.msg);
                alert(rsp.data.msg);
                window.location.href = "/";

            }).catch((err) => {
                if (err.response && err.response.status === 422) {
                    const data = err.response.data || {};
                    if (typeof data.err === 'string') {
                        setmainErrMsg(data.err);
                    } else if (data.errors) {
                        setErrMsg(data.errors);
                    } else {
                        setmainErrMsg(data.msg || 'Validation error');
                    }
                } else if (err.response && err.response.status === 401) {
                    setmainErrMsg('User unauthorized');
                } else {
                    setmainErrMsg('Network or server error');
                }
            }).finally(() => {
                setIsSubmitting(false);
            });
        

    }
    return (
<div><Header title=""/>
        <div class="app-content content" style={{ backgroundColor: "azure" }}>
            <div class="content-overlay"></div>
            <div class="content-wrapper" >
                <div class="content-header row">
                </div>
                <div class="content-body">

                    <div class="row">
                        <div class="col-3"></div>
                        <div class="col-6 box-shadow-2 p-0">


                            <div class="card border-grey border-lighten-3 m-0" >
                                <div className="card-header border-0 pb-0">
                                    <div className="card-title text-center">
                                    <img style={{width:'13%',height:'0%'}} src="/app-assets/images/logo/app-user.png" alt="user logo"/>
                                    </div>
                                    <h6 className="card-subtitle line-on-side text-muted text-center font-medium-5 pt-2"><span> Change Password</span>
                                    
                                    </h6>
                                    <div className="card-title text-center">
                                    
                                    </div>
                                    
                                </div>
                                <div className="card-content" >
                                    <div className="card-body">
                                        <form className="form-horizontal" onSubmit={handleForm} noValidate>

                                            
                                            
                                        <div className="row">
                                                    <div className="col-12 col-sm-12 col-md-12">
                                                    <h6 class="text-center font-weight-bold text-danger">{mainerr_msg}</h6>
                                                        <fieldset className="form-group position-relative has-icon-left">
                                                            <input type="password" name="currentpassword" id="currentpassword" className={`form-control ${err_msg.currentpassword ? 'is-invalid' : ''}`} value={currentpassword} onChange={(e) => { setcurrentPassword(e.target.value) }} placeholder="Current Password" tabIndex={3} required />
                                                            <div className="form-control-position">
                                                                <i className="la la-key" />
                                                            </div>
                                                            <div className="help-block font-small-3" />
                                                            <span className="text-danger">{err_msg.currentpassword ? err_msg.currentpassword : ''}</span>
                                                        </fieldset>
                                                    </div>
                                                    </div>
                                                <div className="row">
                                                    <div className="col-12 col-sm-12 col-md-12">
                                                        <fieldset className="form-group position-relative has-icon-left">
                                                            <input type={showNewPassword ? 'text' : 'password'} name="newpassword" id="newpassword" className={`form-control ${err_msg.newpassword ? 'is-invalid' : ''}`} value={newpassword} onChange={(e) => { setnewPassword(e.target.value) }} placeholder="New Password" tabIndex={3} required />
                                                            <div className="form-control-position">
                                                                <i className="la la-key" />
                                                            </div>
                                                            <div
                                                                role="button"
                                                                tabIndex={0}
                                                                title="Hold to reveal password"
                                                                aria-label="Hold to reveal password"
                                                                style={{position: 'absolute', right: '12px', top: '50%', transform: 'translateY(-50%)', cursor: 'pointer', color: showNewPassword ? '#0f5132' : '#495057'}}
                                                                onMouseDown={() => setShowNewPassword(true)}
                                                                onMouseUp={() => setShowNewPassword(false)}
                                                                onMouseLeave={() => setShowNewPassword(false)}
                                                                onTouchStart={() => setShowNewPassword(true)}
                                                                onTouchEnd={() => setShowNewPassword(false)}
                                                                onKeyDown={(e) => { if (e.key === ' ' || e.key === 'Enter') setShowNewPassword(true); }}
                                                                onKeyUp={(e) => { if (e.key === ' ' || e.key === 'Enter') setShowNewPassword(false); }}
                                                            >
                                                                <i className={showNewPassword ? 'la la-eye-slash' : 'la la-eye'} style={{fontSize: '1.05rem'}} />
                                                            </div>
                                                            <div className="help-block font-small-3" />
                                                            <span className="text-danger">{err_msg.newpassword ? err_msg.newpassword : ''}</span>
                                                        </fieldset>
                                                        <div className="mt-2">
                                                            <ul className="list-unstyled mb-0 small">
                                                                <li className={validMinLength ? 'text-success' : 'text-danger'}><i className={validMinLength ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least 8 characters</li>
                                                                <li className={validUpper ? 'text-success' : 'text-danger'}><i className={validUpper ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one uppercase letter</li>
                                                                <li className={validLower ? 'text-success' : 'text-danger'}><i className={validLower ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one lowercase letter</li>
                                                                <li className={validDigit ? 'text-success' : 'text-danger'}><i className={validDigit ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one digit</li>
                                                                <li className={validSpecial ? 'text-success' : 'text-danger'}><i className={validSpecial ? 'la la-check-circle mr-1' : 'la la-times-circle mr-1'}></i> At least one special character</li>
                                                            </ul>
                                                        </div>
                                                    </div>
                                                    </div>
                                                    {cookies.get('cc')}
                                                <div className="row">
                                                    <div className="col-12 col-sm-12 col-md-12">
                                                        <fieldset className="form-group position-relative has-icon-left">
                                                            <input type="password" name="confirmpass" id="confirmpass" className={`form-control ${err_msg.confirmpass ? 'is-invalid' : ''}`} value={confirmpass} onChange={(e) => { setConfirmPassword(e.target.value) }} placeholder="Confirm Password" tabIndex={3} required />
                                                            <div className="form-control-position">
                                                            <i className="la la-key" />
                                                            </div>
                                                            <div className="help-block font-small-3" />
                                                            <span className="text-danger">{err_msg.confirmpass ? err_msg.confirmpass : ''}</span>
                                                        </fieldset>
                                                    </div>
                                                    </div>
                                                    
                                                
                                            

                                            

                                            <div class="pl-0">
                                                <button type="submit" className="btn btn-info btn-block" disabled={isSubmitting}>
                                                    {isSubmitting ? (
                                                        <>
                                                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                                                            Changing Password...
                                                        </>
                                                    ) : (
                                                        <>
                                                            <i className="la la-user" />
                                                            Change Password
                                                        </>
                                                    )}
                                                </button>
                                            </div>

                                        </form>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                </div>
            </div>
        </div>
        </div>


    )
}
export default ChangePass;